import { ISelectOption } from 'app/interfaces/ISelectOption';
import { Type } from 'shell-models-lib';

export type TeradataAdditionalPropertiesKeyType =
    | 'sslMode'
    | 'portNumber'
    | 'httpsPortNumber'
    | 'useDataEncryption'
    | 'characterSet'
    | 'maxRespSize';

export const teradataAdditionalFieldsKeyOptions: Array<ISelectOption<TeradataAdditionalPropertiesKeyType>> = [
    {
        label: 'Port number',
        value: 'portNumber',
        type: Type.Int
    },
    {
        label: 'HTTPS port number',
        value: 'httpsPortNumber',
        type: Type.Int
    },
    {
        label: 'Use data encryption',
        value: 'useDataEncryption',
        type: Type.Int
    },
    {
        label: 'Character set',
        value: 'characterSet',
        type: Type.String
    },
    {
        label: 'Max resp size',
        value: 'maxRespSize',
        type: Type.Int
    }
];

export enum SSLMode {
    Disable = 'Disable',
    Allow = 'Allow',
    Prefer = 'Prefer',
    Require = 'Require',
    VerifyCa = 'Verify-CA',
    VerifyFull = 'Verify-Full'
}

export const sslModeOptions: Array<ISelectOption<SSLMode>> = [
    {
        label: SSLMode.Disable,
        value: SSLMode.Disable
    },
    {
        label: SSLMode.Allow,
        value: SSLMode.Allow
    },
    {
        label: SSLMode.Prefer,
        value: SSLMode.Prefer
    },
    {
        label: SSLMode.Require,
        value: SSLMode.Require
    },
    {
        label: SSLMode.VerifyCa,
        value: SSLMode.VerifyCa
    },
    {
        label: SSLMode.VerifyFull,
        value: SSLMode.VerifyFull
    }
];

export const teradataAdditionalFieldsAllowedKeys: TeradataAdditionalPropertiesKeyType[] = teradataAdditionalFieldsKeyOptions.map((option) => option.value);
